/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DuplicateDashboardRequestBody,
  DuplicateDashboardRequestBody$Outbound,
  DuplicateDashboardRequestBody$outboundSchema,
} from "../components/duplicatedashboardrequestbody.js";

export type DuplicateDashboardSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type DuplicateDashboardRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  duplicateDashboardRequestBody: DuplicateDashboardRequestBody;
};

/** @internal */
export type DuplicateDashboardSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DuplicateDashboardSecurity$outboundSchema: z.ZodMiniType<
  DuplicateDashboardSecurity$Outbound,
  DuplicateDashboardSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function duplicateDashboardSecurityToJSON(
  duplicateDashboardSecurity: DuplicateDashboardSecurity,
): string {
  return JSON.stringify(
    DuplicateDashboardSecurity$outboundSchema.parse(duplicateDashboardSecurity),
  );
}

/** @internal */
export type DuplicateDashboardRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  DuplicateDashboardRequestBody: DuplicateDashboardRequestBody$Outbound;
};

/** @internal */
export const DuplicateDashboardRequest$outboundSchema: z.ZodMiniType<
  DuplicateDashboardRequest$Outbound,
  DuplicateDashboardRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    duplicateDashboardRequestBody: DuplicateDashboardRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      duplicateDashboardRequestBody: "DuplicateDashboardRequestBody",
    });
  }),
);

export function duplicateDashboardRequestToJSON(
  duplicateDashboardRequest: DuplicateDashboardRequest,
): string {
  return JSON.stringify(
    DuplicateDashboardRequest$outboundSchema.parse(duplicateDashboardRequest),
  );
}
